import React, {useRef, useState} from "react";
import {validateMode} from "root/Modals/modalFunctions";
import Modal from "react-responsive-modal";
import ModalLunchReport from "root/s360components/Modals/LunchReport/ModalLunchReport";


export const ModalLunchReportModes = {
    VIEW: 'view',
    ERROR: 'error',
    VALIDATE: 'validate',
    NONE: 'none'
}

const useModalLunchReport = () =>
{

    const defaultState =  { openState: false, mode: null, error: null, message: null } ;

    const [dialog, setDialog]  = useState ( defaultState )  ;

    //Success of submission
    const resolvePromise = useRef(null);

    const onClickActivate = ( { mode, error, message } ) =>
    {
        validateMode(mode, ModalLunchReportModes);

        return new Promise((resolve, reject) => {

            resolvePromise.current = resolve ;

            switch ( mode )
            {
                case ModalLunchReportModes.VIEW:
                    setDialog ({ openState: true, mode: mode, error: null, message: null});
                    break ;
                case ModalLunchReportModes.ERROR:
                    setDialog ({ openState: true, mode: mode, error: error, message: message});
                    break ;
                case ModalLunchReportModes.VALIDATE:
                    setDialog ({ openState: true, mode: mode, error: null, message: message});
                    break ;
            }
        })
    }

    const onCloseModal = () =>
    {
        setDialog (defaultState);

        if ( resolvePromise.current !== null )
        {
            resolvePromise.current ( 'cancel' ) ;
        }
    };

    const onSaveComplete = ( result ) =>
    {
        // Close the dialog
        setDialog (defaultState);

        // Tell the parent we're done
        if ( resolvePromise.current !== null )
        {
            resolvePromise.current ( result ) ;
        }
    };

    const render = ( ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                < ModalLunchReport onClose={onCloseModal}  mode={dialog.mode} error={dialog.error} message={dialog.message} onSaveComplete={onSaveComplete}/>
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalLunchReport;